import React, {Fragment} from "react"
import {AlphabetSection, PromotedBrandsContainer} from "./components"
import {FacetState} from "../../../../models/FacetsState"
import SingleFacet from "../singleFacet"
import {TextModel} from "../../../../models/Text"
import {sortFacetStateAlphabatically} from "../../../../utils/sortFacetsAlphabatically"
import FacetsWrapper from "./FacetsWrapper"

interface AlphabeticallySortedFacetListProps {
    filterName: string
    facets: FacetState[]
    handleSetFacet: (facetValue: string, filterName: string) => void
    isEnterKeyDown: boolean
    updateNumberOfFacetsLoaded: (filterName: string) => void
    lazyLoadFacets: boolean
    siteUrl: string
    popularFacetCount: number
    text: TextModel
}

export const AlphabeticallySortedFacetList = ({
    filterName,
    facets,
    handleSetFacet,
    isEnterKeyDown,
    updateNumberOfFacetsLoaded,
    lazyLoadFacets,
    siteUrl,
    popularFacetCount,
    text,
}: AlphabeticallySortedFacetListProps) => {
    const handleScroll = e => {
        if (lazyLoadFacets) {
            const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10
            if (bottom) {
                updateNumberOfFacetsLoaded(filterName)
            }
        }
    }
    const alphabeticalOrderFilters = sortFacetStateAlphabatically(facets.slice(popularFacetCount))

    return (
        <FacetsWrapper onScroll={handleScroll} dataTestId={`plp-horizontal-filters-${filterName}-scroll`}>
            <>
                <PromotedBrandsContainer data-testid="plp-horizontal-filters-facets-panel-promoted-brands">
                    <>
                        {popularFacetCount > 0 && (
                            <AlphabetSection data-testid="plp-horizontal-filters-brand-alphabet-title-promoted">
                                {`${text.pages.filters.popularText} ${filterName}s`}
                            </AlphabetSection>
                        )}
                        {facets.slice(0, popularFacetCount).map((facet, i) => (
                            <SingleFacet
                                facet={facet}
                                handleSetFacet={() => handleSetFacet(facet.v, filterName)}
                                filterName={filterName}
                                showCount
                                shouldGetFocus={i === 0 && isEnterKeyDown}
                                key={facet.n}
                                siteUrl={siteUrl}
                            />
                        ))}
                    </>
                </PromotedBrandsContainer>
                <PromotedBrandsContainer data-testid="plp-horizontal-filters-facets-other-brands">
                    {Object.keys(alphabeticalOrderFilters)
                        .sort()
                        .map(letter => (
                            <Fragment key={letter}>
                                <AlphabetSection data-testid={`plp-horizontal-filters-brand-alphabet-title-${letter}`}>
                                    {letter}
                                </AlphabetSection>
                                {alphabeticalOrderFilters[letter].sort().map((facet, i) => (
                                    <SingleFacet
                                        facet={facet}
                                        handleSetFacet={() => handleSetFacet(facet.v, filterName)}
                                        filterName={filterName}
                                        showCount
                                        shouldGetFocus={i === 0 && isEnterKeyDown}
                                        key={facet.n}
                                        siteUrl={siteUrl}
                                    />
                                ))}
                            </Fragment>
                        ))}
                </PromotedBrandsContainer>
            </>
        </FacetsWrapper>
    )
}

export default AlphabeticallySortedFacetList
